import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://dxesmzogjpxswxhsomgf.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR4ZXNtem9nanB4c3d4aHNvbWdmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc2NjY3OTksImV4cCI6MjA2MzI0Mjc5OX0.ox8TyfcDVvEAKtf9zQTLSPH_6D6ICLhM99ZxKscs0OY';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  }
});

// Helper function to synchronize user with Django backend
export const syncUserWithDjango = async (userData) => {
  try {
    const { data, error } = await supabase.functions.invoke('sync-user-with-django', {
      body: userData
    });
    
    if (error) throw error;
    return { data, error: null };
  } catch (error) {
    console.error('Error syncing user with Django:', error);
    return { data: null, error };
  }
};